import { type Location } from '!/router'
import { Logger } from '@/logger'
import * as Sentry from '@sentry/browser'
import { UNKNOWN_PREVIOUS_LOCATION } from './index.h'

export const logger = new Logger('tria/sentry')

/**
 * Composes href from location
 */
const href = (location?: Location | null): string =>
  location
    ? `${location.pathname}${location.search}${location.hash}`
    : UNKNOWN_PREVIOUS_LOCATION

/**
 * Composes breadcrumbs from previous locations
 */
export const toBreadcrumbs = (locations: (Location | null)[] | null) =>
  locations ? locations.map(href).reverse() : []

/**
 * Checks if the error is a VideoJS error
 */
export function isVideoJsError(event: Sentry.Event): boolean {
  if (!Array.isArray(event?.extra?.arguments)) {
    return false
  }

  const isVideoJsError = event.extra.arguments.some((arg) =>
    arg.includes('VIDEOJS')
  )

  return isVideoJsError
}

/**
 * Checks if the error is related to Firebase Analytics and QuotaExceededError
 */
export function isFirebaseAnalyticsError(event: Sentry.Event): boolean {
  if (!Array.isArray(event?.extra?.arguments)) {
    return false
  }

  let hasFBAnalytics = false
  let hasQuotaExceeded = false

  for (const arg of event.extra.arguments) {
    if (arg.includes('@firebase/analytics')) {
      hasFBAnalytics = true
    }
    if (arg.name?.includes('QuotaExceededError')) {
      hasQuotaExceeded = true
    }

    if (hasFBAnalytics && hasQuotaExceeded) {
      return true
    }
  }

  return false
}

/**
 * Checks if the error is ignored
 */
export const isIgnoredError = (event: Sentry.Event): boolean => {
  return isVideoJsError(event) || isFirebaseAnalyticsError(event)
}
